import { addCardsOpenModalListener } from '@tools/reviews_slider.js';

export function initReviewsPagination() {
  const slider = document.querySelector('.reviews-page-slider');

  if (!slider) {
    return;
  }

  const cards = Array.from(
    slider.querySelectorAll('.reviews-page-slider-body .card')
  );

  if (!cards.length) {
    return;
  }

  addCardsOpenModalListener('.reviews-page-slider');

  const currentPage = Number(slider.dataset.page) || 1;
  const totalPages = Number(slider.dataset.totalPages) || 1;

  const prevButtons = slider.querySelectorAll('.pagination-prev');
  const nextButtons = slider.querySelectorAll('.pagination-next');

  const isMobile = () => window.matchMedia(
    '(max-width: 767px)'
  ).matches;

  let mobilePart = 0;

  function updateButtons() {
    const mobile = isMobile();

    prevButtons.forEach(button => {
      button.disabled = mobile
        ? currentPage === 1 && mobilePart === 0
        : currentPage === 1;
    });

    nextButtons.forEach(button => {
      button.disabled = mobile
        ? (
            currentPage === totalPages &&
            mobilePart === 1
          )
        : currentPage === totalPages;
    });
  }

  function showMobilePart(part) {
    const start = part * 50;
    const end = start + 50;

    cards.forEach((card, index) => {
      card.style.display = index >= start && index < end
        ? ''
        : 'none';
    });

    mobilePart = part;
    updateButtons();
  }

  function goToPage(page) {
    if (page < 1 || page > totalPages) {
      return;
    }

    const url = page === 1
      ? '/reviews/#reviews-page-slider'
      : `/reviews/page-${page}/#reviews-page-slider`;

    window.location.href = url;
  }

  prevButtons.forEach(button => {
    button.addEventListener('click', () => {
      if (isMobile()) {
        if (mobilePart === 1) {
          showMobilePart(0);
        } else if (currentPage > 1) {
          goToPage(currentPage - 1);
        }
      } else if (currentPage > 1) {
        goToPage(currentPage - 1);
      }
    });
  });

  nextButtons.forEach(button => {
    button.addEventListener('click', () => {
      if (isMobile()) {
        if (mobilePart === 0 && cards.length > 50) {
          showMobilePart(1);
        } else if (currentPage < totalPages) {
          goToPage(currentPage + 1);
        }
      } else if (currentPage < totalPages) {
        goToPage(currentPage + 1);
      }
    });
  });

  if (isMobile()) {
    showMobilePart(0);
  } else {
    cards.forEach(card => {
      card.style.display = '';
    });
    updateButtons();
  }

  window.addEventListener('resize', () => {
    if (isMobile()) {
      showMobilePart(mobilePart);
    } else {
      cards.forEach(card => {
        card.style.display = '';
      });
      updateButtons();
    }
  });
}